import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsInternalUserGroupsTestUserCacheKeys: AllRouteEndpoints[] = [
  "/internal_user_groups/:internal_user_group_id/test_users_v2",
  "/internal_user_groups/test_user_names",
];
